/**
 * This type is used together with the {@link ExplicitAnchors} type. What the values mean:
 * - OnlyOriginalAnchors - The original anchors are kept, unless explicitly overriden by notAnchored property inside the {@link ExplicitAnchors}
 * - MergeWithOriginalAnchors - Use the values in {@link ExplicitAnchors} and if some value is missing, use the original value in visual model.
 * - OnlyGivenAnchors - Only the values given in anchored are anchored.
 * - AnchorEverythingExceptNotAnchored - Everything which is not part of the notAnchored property will be anchored
 */
export var AnchorOverrideSetting;
(function (AnchorOverrideSetting) {
    AnchorOverrideSetting[AnchorOverrideSetting["OnlyOriginalAnchors"] = 0] = "OnlyOriginalAnchors";
    AnchorOverrideSetting[AnchorOverrideSetting["MergeWithOriginalAnchors"] = 1] = "MergeWithOriginalAnchors";
    AnchorOverrideSetting[AnchorOverrideSetting["OnlyGivenAnchors"] = 2] = "OnlyGivenAnchors";
    AnchorOverrideSetting[AnchorOverrideSetting["AnchorEverythingExceptNotAnchored"] = 3] = "AnchorEverythingExceptNotAnchored";
})(AnchorOverrideSetting || (AnchorOverrideSetting = {}));
;
/**
 * @param defaultAnchorValue This value is relevant for the "merge-with-original-anchors" and "only-original-anchors" cases,
 * since if it isn't overriden using the {@link explicitAnchors} then we return the given default.
 * @returns
 */
export function isEntityWithIdentifierAnchored(identifier, explicitAnchors, defaultAnchorValue) {
    let isAnchored = defaultAnchorValue;
    switch (explicitAnchors.shouldAnchorEverythingExceptNotAnchored) {
        case AnchorOverrideSetting.MergeWithOriginalAnchors:
            if (explicitAnchors.anchored.find(id => identifier === id)) {
                isAnchored = true;
            }
            else {
                if (explicitAnchors.notAnchored.find(id => identifier === id)) {
                    isAnchored = false;
                }
                // Else keep the old value
            }
            break;
        case AnchorOverrideSetting.OnlyGivenAnchors:
            if (explicitAnchors.anchored.find(id => identifier === id)) {
                isAnchored = true;
            }
            else {
                isAnchored = false;
            }
            break;
        case AnchorOverrideSetting.OnlyOriginalAnchors:
            if (explicitAnchors.notAnchored.find(id => identifier === id)) {
                isAnchored = false;
            }
            break;
        case AnchorOverrideSetting.AnchorEverythingExceptNotAnchored:
            if (explicitAnchors.notAnchored.find(id => identifier === id)) {
                isAnchored = false;
            }
            else {
                isAnchored = true;
            }
            break;
        default:
            throw new Error("Forgot to extend switch for Explicit Anchors");
    }
    return isAnchored;
}
//# sourceMappingURL=explicit-anchors.js.map